module.exports = __webpack_public_path__ + "img/section5.2e50d08f.svg";